import angular from 'angular';
import { AddSatisfactionSurveyController } from './satisfaction-survey.add.controller.js';
import { SatisfactionSurveyDetailsController } from './satisfaction-survey.details.controller.js';
import { SatisfactionSurveysController } from './satisfaction-surveys.controller.js';

angular
  .module('parameters.satisfaction-surveys', [])
  .controller('SatisfactionSurveysController', SatisfactionSurveysController)
  .controller('SatisfactionSurveyDetailsController', SatisfactionSurveyDetailsController)
  .controller('AddSatisfactionSurveyController', AddSatisfactionSurveyController)
